module.exports = {
  SAAS: 'saas',
  ENTERPRISE: 'enterprise',
};
